module.exports = "dist/images/block-footer-img1.ec46a6c.png";